import Header from '@/components/Header';
import Footer from '@/components/Footer';

const TermsOfService = () => {
  return (
    <>
      <Header />
      
      <section className="py-20 bg-white" data-testid="terms-of-service-page">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold mb-8">Terms of Service</h1>
            <p className="text-gray-600 mb-8">Last Updated: January 2026</p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-3xl font-bold mb-4">1. Acceptance of Terms</h2>
                <p>
                  By accessing and using the services of Trademark Scribe, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">2. Services Description</h2>
                <p>
                  Trademark Scribe provides trademark registration, copyright services, patent services, business formation, and related legal support services. Our services do not constitute legal advice, and we recommend consulting with an attorney for complex legal matters.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">3. User Obligations</h2>
                <p className="mb-4">You agree to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the confidentiality of your account credentials</li>
                  <li>Notify us immediately of any unauthorized use of your account</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not use our services for any unlawful purpose</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">4. Fees and Payment</h2>
                <p>
                  Service fees are as quoted and must be paid in accordance with the payment terms provided. Government filing fees are separate and must be paid in addition to our service fees. Fees are non-refundable except as expressly stated in our refund policy.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">5. No Guarantee of Results</h2>
                <p>
                  While we make every effort to provide high-quality services, we cannot guarantee that trademark or patent applications will be approved by government authorities. Approval depends on various factors including trademark availability and compliance with legal requirements.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">6. Intellectual Property</h2>
                <p>
                  All content on our website, including text, graphics, logos, and software, is the property of Trademark Scribe and is protected by copyright and trademark laws. You may not use our intellectual property without our express written permission.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">7. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Trademark Scribe shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for our services.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">8. Indemnification</h2>
                <p>
                  You agree to indemnify and hold harmless Trademark Scribe from any claims, damages, losses, liabilities, and expenses arising from your use of our services or violation of these terms.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">9. Privacy</h2>
                <p>
                  Your use of our services is also governed by our Privacy Policy. Please review our Privacy Policy to understand how we collect and use your information.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">10. Dispute Resolution</h2>
                <p>
                  Any disputes arising from these terms or our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association, except where prohibited by law.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">11. Modifications to Terms</h2>
                <p>
                  We reserve the right to modify these Terms of Service at any time. We will notify users of material changes by posting the updated terms on our website. Your continued use of our services after changes constitutes acceptance of the modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">12. Termination</h2>
                <p>
                  We may terminate or suspend your access to our services at any time, with or without cause or notice. Upon termination, your right to use our services will immediately cease.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">13. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">14. Contact Information</h2>
                <p>
                  For questions about these Terms of Service, please contact us at:
                </p>
                <p className="mt-4">
                  <strong>Trademark Scribe</strong><br />
                  7500 Monterey Rd<br />
                  Gilroy, CA 95020<br />
                  United States<br /><br />
                  Email: info@trademarkscribe.com<br />
                  Phone: (888) 608-2752
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default TermsOfService;